// Reusable multi-select category filter — tick multiple categories, type to
// filter. Used by every module's category search (products, imports, orders,
// transfers, stock). Stores selected category ids as string[].
import { MultiSelect } from "@/components/ui/multi-select";
import { useCategoriesQuery } from "./use-categories";
import { flattenCategories } from "./types";

interface Props {
  values: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  className?: string;
}

export function CategoryMultiSelect({
  values,
  onChange,
  placeholder = "Tất cả danh mục",
  className,
}: Props) {
  const { data: catTree = [] } = useCategoriesQuery();
  const options = flattenCategories(catTree).map((c) => ({ value: c.id, label: c.label.trim() }));
  return (
    <MultiSelect
      values={values}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      className={className}
    />
  );
}
